import { render, staticRenderFns } from "./license-info.vue?vue&type=template&id=258da2b6&"
import script from "./license-info.vue?vue&type=script&lang=js&"
export * from "./license-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports